<template>
  <div>
    <!-- <i class="el-icon-message-solid"  @click="click" ></i> -->
    <i class="el-icon-message-solid" />
    <span>{{ infonum }}</span>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {

  },
  created() {

  },
  computed: {
    ...mapGetters([
      'infonum'
    ])
  },
  methods: {

    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
